var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],attrs:{"id":"spinner"}},[_c('b-spinner',{style:(_vm.GetStyle()),attrs:{"variant":_vm.variant}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }